import React from 'react';
import PropTypes from 'prop-types';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';

class OrderDisplay extends NamespaceConsumer {
  render() {
    const {
      items,
      itemsTitle,
      subTotal,
      subTotalPrefix,
      taxesTotal,
      taxesTotalPrefix
    } = this.props;

    return (
      <div className={ this.namespace('font-base', 'order-display') }>
        {itemsTitle && <span>{itemsTitle}</span>}
        {items && items.length > 0 && (
          <ul>
            {items.map(item => (
              item.name && (
                <li key={ item.name }>
                  <strong>{item.name} <br />
                    <small>{item.term}</small>
                  </strong>
                </li>
              )
            ))
            }
          </ul>
        )}
        <p>
          {subTotalPrefix && subTotal && <small>{subTotalPrefix} <strong>{subTotal}</strong></small>}
          {taxesTotalPrefix && taxesTotal && <small>{taxesTotalPrefix} <strong>{taxesTotal}</strong></small>}
        </p>
      </div>
    );
  }
}

OrderDisplay.propTypes = {
  ...NamespaceShape,
  items: PropTypes.array,
  itemsTitle: PropTypes.string,
  subTotal: PropTypes.string,
  subTotalPrefix: PropTypes.string,
  taxesTotal: PropTypes.string,
  taxesTotalPrefix: PropTypes.string
};

export default withNamespace(OrderDisplay);
